import { SectionHeader } from "@/components/SectionHeader";
import { JsonLd } from "@/components/JsonLd";
import { faqPageJsonLd, type FaqItem } from "@/lib/schema";

type Props = {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  faqs: FaqItem[];
};

export function FaqSection({
  eyebrow = "FAQ",
  title = "Questions we hear a lot.",
  subtitle,
  faqs,
}: Props) {
  if (faqs.length === 0) return null;

  return (
    <section className="bg-background py-24">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <SectionHeader eyebrow={eyebrow} title={title} subtitle={subtitle} />
        <div className="mt-12 max-w-3xl divide-y divide-border border-t border-border">
          {faqs.map((faq) => (
            <details key={faq.question} className="group py-5">
              <summary className="cursor-pointer list-none font-display text-lg tracking-wider text-foreground marker:content-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden">
                <span className="flex items-start justify-between gap-4">
                  {faq.question}
                  <span
                    className="mt-1 shrink-0 font-display text-accent transition group-open:rotate-45"
                    aria-hidden="true"
                  >
                    +
                  </span>
                </span>
              </summary>
              <p className="mt-3 text-sm leading-6 text-muted-foreground md:text-base">
                {faq.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
      <JsonLd data={faqPageJsonLd(faqs)} />
    </section>
  );
}
